export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-16 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-heading font-bold text-white mb-4 inline-block">
              黑料在线
            </span>
            <p className="text-sm text-white/55 leading-relaxed mb-4">
              黑料在线是领先的黑料视频聚合平台，提供海量黑料视频正片的在线观看与在线播放服务。每日更新最新黑料大瓜，覆盖网红爆料、明星八卦、综艺揭秘等多元内容，高清免注册免费观看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '关于我们', href: '#about' },
                { label: '最新快讯', href: '#updates' },
                { label: '专题合集', href: '#index' },
                { label: '精选黑料', href: '#cards' },
                { label: '常见问答', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-white/50 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门话题</h4>
            <div className="flex flex-col gap-2.5">
              {['网红爆料', '明星八卦', '综艺揭秘', 'MCN深挖', '商业爆料'].map((item) => (
                <a
                  key={item}
                  href="#cards"
                  className="text-sm text-white/50 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              更多优质合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/35 text-center sm:text-left">
            &copy; 2026 黑料在线. 本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-white/35 hover:text-white/60 transition-colors whitespace-nowrap cursor-pointer">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}